__turbopack_context__.v({
  "empty": "empty-module-scss-module__mlDIwa__empty",
});
